import React, { useState, useEffect } from 'react';

import { Form, Button, Breadcrumb } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';

import DepartementService from 'Services/DepartementService';

const Apps = (props) => {
    const history = useHistory();
    const [departement, setDepartement] = useState(null);
    const { register, handleSubmit, errors } = useForm();

    const {
        match: { params },
    } = props;

    useEffect(() => {
        if (params.departementId) {
            DepartementService.getDepartementById(params.departementId)
                .then((result) => {
                    if (result.status === 200) {
                        setDepartement(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params]);

    const onSubmit = (data) => {
        DepartementService.saveDepartement({ departementId: params.departementId, ...data })
            .then((result) => {
                if (result.status === 200) {
                    history.push('/admin/departement/index');
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item>
                    <Link to="/">Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/admin">Admin</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/admin/departement/index">Departement</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                    {params.departementId ? 'Edit Departement' : 'Create New Departement'}
                </Breadcrumb.Item>
            </Breadcrumb>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">{params.departementId ? 'Edit Departement' : 'Create New Departement'}</h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{params.departementId}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                    {errors.exampleRequired && <span>This field is required</span>}

                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Nom</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Nom"
                                name="nom"
                                defaultValue={departement ? departement.nom : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>CodeInterne</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="CodeInterne"
                                name="codeInterne"
                                defaultValue={departement ? departement.codeInterne : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" block>
                            Submit
                        </Button>
                    </Form>
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default Apps;
